var _symbol, _symbol2, _path, _path2, _symbol3, _circle, _symbol4, _symbol5, _symbol6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "smartphone",
    width: 20,
    height: 32,
    viewBox: "0 0 20 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M17 0h-14c-1.654 0-3 1.346-3 3v26c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-26c0-1.654-1.346-3-3-3zM3 2h14c0.552 0 1 0.448 1 1v0 21h-16v-21c0-0.552 0.448-1 1-1v0zM17 30h-14c-0.552 0-1-0.448-1-1v0-3h16v3c0 0.552-0.448 1-1 1v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M4.708 27.478c0.18 0.163 0.293 0.399 0.293 0.66s-0.113 0.497-0.292 0.659l-0.001 0.001c-0.186 0.17-0.435 0.275-0.708 0.275s-0.522-0.104-0.709-0.275l0.001 0.001c-0.18-0.163-0.293-0.399-0.293-0.66s0.113-0.497 0.292-0.659l0.001-0.001c0.186-0.17 0.435-0.275 0.708-0.275s0.522 0.104 0.709 0.275l-0.001-0.001z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H2.5C1.4 0 0.51 0.9 0.51 2L0.5 14C0.5 15.1 1.4 16 2.5 16H18.5C19.6 16 20.5 15.1 20.5 14V2C20.5 0.9 19.6 0 18.5 0ZM18.5 4L10.5 9L2.5 4V2L10.5 7L18.5 2V4Z",
    fill: "#E0E0E0"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "name",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    fill: "#E0E0E0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.769,207.788c0,35.83,12.712,72.124,34.877,99.574c23.268,28.815,53.618,44.685,85.459,44.685c31.835,0,62.147-15.86,85.353-44.659c22.091-27.416,34.761-63.695,34.761-99.535v-32.07 c23.499-74.602,14.779-137.595,7.134-154.97c-0.012-0.027-0.027-0.052-0.04-0.079c-0.072-0.159-0.152-0.313-0.234-0.467 c-0.045-0.084-0.088-0.171-0.136-0.253c-0.08-0.137-0.167-0.268-0.254-0.399c-0.062-0.093-0.121-0.188-0.186-0.277 c-0.078-0.107-0.162-0.209-0.246-0.312c-0.083-0.104-0.165-0.209-0.252-0.307c-0.075-0.084-0.155-0.162-0.233-0.243 c-0.103-0.106-0.204-0.214-0.313-0.313c-0.079-0.073-0.163-0.14-0.245-0.21c-0.113-0.096-0.224-0.193-0.342-0.282 c-0.097-0.074-0.199-0.14-0.299-0.209c-0.108-0.074-0.214-0.152-0.325-0.22c-0.127-0.079-0.259-0.149-0.39-0.22 c-0.09-0.049-0.177-0.102-0.269-0.147c-0.156-0.078-0.318-0.146-0.48-0.214c-0.072-0.03-0.142-0.064-0.214-0.092 c-0.173-0.067-0.35-0.122-0.528-0.177c-0.067-0.021-0.134-0.045-0.201-0.064c-0.169-0.047-0.342-0.083-0.515-0.119 c-0.083-0.017-0.165-0.038-0.249-0.053c-0.148-0.026-0.299-0.042-0.449-0.059c-0.115-0.013-0.23-0.03-0.346-0.038 c-0.119-0.008-0.24-0.009-0.36-0.012c-0.151-0.004-0.302-0.009-0.453-0.004c-0.095,0.003-0.19,0.012-0.285,0.018 c-0.177,0.011-0.353,0.025-0.53,0.049c-0.027,0.003-0.054,0.003-0.081,0.007c-20.062,2.865-44.351-2.012-70.066-7.175 c-43.121-8.658-87.673-17.581-122.508,7.26c-0.524-0.108-1.066-0.165-1.622-0.165c-35.729,0-60.682,29.608-60.682,72.002 c0,32.772,13.789,93.919,15.748,102.441V207.788z M328.999,297.349c-20.108,24.955-45.996,38.698-72.894,38.698 c-26.911,0-52.84-13.757-73.01-38.736c-19.908-24.655-31.326-57.284-31.326-89.522v-9.111c0-28.498,16.161-66.981,21.655-79.238 c55.276-6.495,99.31-0.006,126.772,6.703c24.089,5.885,39.896,12.933,45.595,15.701l14.428,34.33v31.68 C360.219,240.106,348.84,272.726,328.999,297.349z M180.703,32.034c0.772,0,1.517-0.115,2.224-0.32 c2.342,0.671,4.958,0.277,7.047-1.31c29.374-22.312,71.23-13.905,111.709-5.778c21.237,4.265,41.546,8.343,60.305,8.343 c2.89,0,5.74-0.109,8.555-0.317c4.922,17.755,9.586,62.524-3.828,117.681l-7.311-17.395c-0.697-1.658-1.932-3.033-3.507-3.903 c-2.952-1.63-73.616-39.764-188.896-24.933c-0.02,0.002-0.038,0.008-0.057,0.01c-0.151,0.021-0.301,0.052-0.45,0.081 c-0.115,0.022-0.231,0.04-0.344,0.067c-0.096,0.023-0.19,0.055-0.286,0.082c-1.021,0.285-1.949,0.761-2.752,1.388 c-0.502,0.39-0.963,0.84-1.367,1.353c-0.018,0.023-0.039,0.044-0.057,0.068c-0.081,0.105-0.154,0.219-0.23,0.329 c-0.075,0.109-0.155,0.215-0.225,0.327c-0.049,0.079-0.092,0.164-0.139,0.246c-0.088,0.152-0.175,0.304-0.253,0.462 c-0.007,0.014-0.016,0.027-0.023,0.042c-0.619,1.282-9.674,20.183-16.721,43.296c-3.985-21.14-8.077-46.957-8.077-63.816 C136.021,49.351,158.463,32.034,180.703,32.034z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.736,414.085c-10.786-15.798-25.828-26.766-43.5-31.717c-0.14-0.039-0.28-0.074-0.422-0.105l-80.257-17.846 c-7.376-1.64-12.528-8.063-12.528-15.62v-4.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v4.75c0,15.112,10.303,27.958,25.055,31.238 l0.808,0.18c-22.386,27.264-58.898,43.835-97.866,43.835c-38.964,0-75.479-16.572-97.865-43.835l0.807-0.179 c14.752-3.28,25.055-16.125,25.055-31.238v-4.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v4.75c0,7.556-5.152,13.979-12.528,15.62 l-80.257,17.846c-0.142,0.031-0.282,0.066-0.422,0.105c-17.672,4.951-32.714,15.918-43.5,31.717 c-9.866,14.451-15.299,31.891-15.299,49.109v19.843c0,15.999,14.355,29.016,32.001,29.016h416.016 c17.646,0,32.001-13.017,32.001-29.016v-19.843C496.035,445.976,490.602,428.536,480.736,414.085z M480.035,483.037 c0,7.177-7.178,13.016-16.001,13.016H48.018c-8.823,0-16.001-5.839-16.001-13.016v-19.843c0-25.893,16.114-56.618,46.913-65.362 l62.013-13.789c24.802,34.649,68.465,56.006,115.083,56.006c46.622,0,90.28-21.357,115.083-56.007l62.013,13.789 c30.799,8.744,46.913,39.469,46.913,65.362V483.037z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "viber",
    viewBox: "0 0 631.99 666.43"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7360f2;}.cls-2{fill:none;stroke:#7360f2;stroke-linecap:round;stroke-linejoin:round;stroke-width:16.86px;}")), /*#__PURE__*/React.createElement("title", null, "Artboard 6"), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.65,65C544.09,49.72,477.17,1.14,328.11.48c0,0-175.78-10.6-261.47,68C18.94,116.19,2.16,186,.39,272.55S-3.67,521.3,152.68,565.28l.15,0-.1,67.11s-1,27.17,16.89,32.71c21.64,6.72,34.34-13.93,55-36.19,11.34-12.22,27-30.17,38.8-43.89,106.93,9,189.17-11.57,198.51-14.61,21.59-7,143.76-22.66,163.63-184.84C646.07,218.4,615.64,112.66,560.65,65Zm18.12,308.58C562,509,462.91,517.51,444.64,523.37c-7.77,2.5-80,20.47-170.83,14.54,0,0-67.68,81.65-88.82,102.88-3.3,3.32-7.18,4.66-9.77,4-3.64-.89-4.64-5.2-4.6-11.5.06-9,.58-111.52.58-111.52s-.08,0,0,0C38.94,485.05,46.65,347,48.15,274.71S63.23,143.2,103.57,103.37c72.48-65.65,221.79-55.84,221.79-55.84,126.09.55,186.51,38.52,200.52,51.24C572.4,138.6,596.1,233.91,578.77,373.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.47,268.77q-2.46-49.59-50.38-52.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.72,283.27q1-46.2-27.37-77.2c-19-20.74-45.3-32.16-79.05-34.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M477,300.59q-.61-80.17-47.91-126.28t-117.65-46.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.76,381.68s11.85,1,18.23-6.86l12.44-15.65c6-7.76,20.48-12.71,34.66-4.81A366.67,366.67,0,0,1,437,374.1c9.41,6.92,28.68,23,28.74,23,9.18,7.75,11.3,19.13,5.05,31.13,0,.07-.05.19-.05.25a129.81,129.81,0,0,1-25.89,31.88c-.12.06-.12.12-.23.18q-13.38,11.18-26.29,12.71a17.39,17.39,0,0,1-3.84.24,35,35,0,0,1-11.18-1.72l-.28-.41c-13.26-3.74-35.4-13.1-72.27-33.44a430.39,430.39,0,0,1-60.72-40.11,318.31,318.31,0,0,1-27.31-24.22l-.92-.92-.92-.92h0l-.92-.92c-.31-.3-.61-.61-.92-.92a318.31,318.31,0,0,1-24.22-27.31,430.83,430.83,0,0,1-40.11-60.71c-20.34-36.88-29.7-59-33.44-72.28l-.41-.28a35,35,0,0,1-1.71-11.18,16.87,16.87,0,0,1,.23-3.84Q141,181.42,152.12,168c.06-.11.12-.11.18-.23a129.53,129.53,0,0,1,31.88-25.88c.06,0,.18-.06.25-.06,12-6.25,23.38-4.13,31.12,5,.06.06,16.11,19.33,23,28.74a366.67,366.67,0,0,1,19.74,30.94c7.9,14.17,2.95,28.68-4.81,34.66l-15.65,12.44c-7.9,6.38-6.86,18.23-6.86,18.23S254.15,359.57,340.76,381.68Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "whatsapp",
    viewBox: "0 0 455.731 455.731",
    style: {
      enableBackground: "new 0 0 455.731 455.731"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    style: {
      fill: "#E5E5E5"
    },
    width: 500,
    height: 455.731
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M68.494,387.41l22.323-79.284c-14.355-24.387-21.913-52.134-21.913-80.638 c0-87.765,71.402-159.167,159.167-159.167s159.166,71.402,159.166,159.167c0,87.765-71.401,159.167-159.166,159.167 c-27.347,0-54.125-7-77.814-20.292L68.494,387.41z M154.437,337.406l4.872,2.975c20.654,12.609,44.432,19.274,68.762,19.274 c72.877,0,132.166-59.29,132.166-132.167S300.948,95.321,228.071,95.321S95.904,154.611,95.904,227.488 c0,25.393,7.217,50.052,20.869,71.311l3.281,5.109l-12.855,45.658L154.437,337.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.359,153.407l-10.328-0.563c-3.244-0.177-6.426,0.907-8.878,3.037 c-5.007,4.348-13.013,12.754-15.472,23.708c-3.667,16.333,2,36.333,16.667,56.333c14.667,20,42,52,90.333,65.667 c15.575,4.404,27.827,1.435,37.28-4.612c7.487-4.789,12.648-12.476,14.508-21.166l1.649-7.702c0.524-2.448-0.719-4.932-2.993-5.98 l-34.905-16.089c-2.266-1.044-4.953-0.384-6.477,1.591l-13.703,17.764c-1.035,1.342-2.807,1.874-4.407,1.312 c-9.384-3.298-40.818-16.463-58.066-49.687c-0.748-1.441-0.562-3.19,0.499-4.419l13.096-15.15 c1.338-1.547,1.676-3.722,0.872-5.602l-15.046-35.201C187.187,154.774,185.392,153.518,183.359,153.407z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "telegram",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M34.133,256c0-135.648,105.508-246.636,238.933-255.421C267.424,0.208,261.737,0,256,0 C114.615,0,0,114.615,0,256s114.615,256,256,256c5.737,0,11.424-0.208,17.067-0.579C139.642,502.636,34.133,391.648,34.133,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M380.263,109.054c-2.486-1.69-5.676-1.946-8.399-0.679L96.777,236.433 c-4.833,2.251-7.887,7.172-7.766,12.501c0.117,5.226,3.28,9.92,8.065,12.015l253.613,110.457c8.468,3.849,18.439-2.21,18.983-11.453 l14.314-243.341C384.161,113.614,382.748,110.742,380.263,109.054z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5E5E5"
    },
    points: "171.631,293.421 188.772,408 379.168,108.432 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M371.866,108.375L96.777,236.433c-4.737,2.205-7.826,7.121-7.769,12.345 c0.058,5.233,3.276,10.074,8.067,12.171l74.557,32.471l207.536-184.988C376.882,107.33,374.203,107.287,371.866,108.375z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5E5E5"
    },
    points: "211.418,310.749 188.772,408 379.168,108.432 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M380.263,109.054c-0.351-0.239-0.72-0.442-1.095-0.622l-167.75,202.317l139.27,60.657 c8.468,3.849,18.439-2.21,18.983-11.453l14.314-243.341C384.161,113.614,382.748,110.742,380.263,109.054z"
  })), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-facebook",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.328 5.312h2.923v-5.088c-1.232-0.143-2.66-0.224-4.108-0.224-0.052 0-0.104 0-0.156 0l0.008-0c-4.213 0-7.099 2.65-7.099 7.52v4.48h-4.646v5.688h4.646v14.312h5.699v-14.31h4.459l0.707-5.688h-5.168v-3.922c0-1.643 0.443-2.768 2.734-2.768z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.968 9.408c-0.074-1.701-0.349-2.869-0.742-3.882-0.424-1.111-1.054-2.059-1.85-2.837l-0.001-0.001c-0.78-0.792-1.724-1.419-2.778-1.827l-0.054-0.018c-1.019-0.394-2.181-0.667-3.882-0.742-1.712-0.082-2.256-0.101-6.602-0.101-4.344 0-4.888 0.019-6.595 0.094-1.699 0.074-2.869 0.349-3.88 0.742-1.112 0.424-2.060 1.054-2.839 1.85l-0.001 0.001c-0.791 0.78-1.418 1.724-1.825 2.778l-0.018 0.054c-0.395 1.019-0.669 2.181-0.744 3.882-0.082 1.712-0.101 2.256-0.101 6.602 0 4.344 0.019 4.888 0.094 6.595 0.075 1.701 0.35 2.869 0.744 3.882 0.426 1.11 1.055 2.057 1.849 2.837l0.001 0.001c0.8 0.813 1.77 1.443 2.832 1.843 1.019 0.395 2.182 0.67 3.882 0.744 1.707 0.075 2.251 0.094 6.595 0.094 4.346 0 4.89-0.019 6.595-0.094 1.701-0.074 2.869-0.349 3.882-0.742 2.157-0.85 3.833-2.526 4.664-4.628l0.019-0.055c0.394-1.019 0.669-2.182 0.744-3.882 0.075-1.707 0.093-2.251 0.093-6.595s-0.006-4.888-0.080-6.595zM29.088 22.474c-0.070 1.563-0.333 2.406-0.55 2.97-0.552 1.399-1.64 2.486-3.004 3.024l-0.036 0.012c-0.56 0.219-1.411 0.482-2.968 0.55-1.688 0.075-2.194 0.094-6.464 0.094-4.269 0-4.782-0.019-6.464-0.094-1.563-0.069-2.406-0.331-2.97-0.55-0.721-0.269-1.334-0.676-1.836-1.192l-0.001-0.001c-0.517-0.503-0.924-1.117-1.184-1.803l-0.011-0.034c-0.218-0.563-0.48-1.413-0.549-2.97-0.075-1.688-0.094-2.195-0.094-6.464 0-4.27 0.019-4.784 0.094-6.464 0.069-1.563 0.331-2.406 0.549-2.97 0.269-0.722 0.678-1.337 1.198-1.837l0.002-0.002c0.504-0.517 1.119-0.923 1.806-1.182l0.034-0.011c0.56-0.219 1.411-0.48 2.968-0.55 1.688-0.074 2.195-0.093 6.464-0.093 4.275 0 4.782 0.019 6.464 0.093 1.563 0.069 2.406 0.331 2.97 0.55 0.693 0.256 1.325 0.662 1.837 1.194 0.531 0.52 0.938 1.144 1.195 1.84 0.218 0.56 0.48 1.411 0.549 2.968 0.075 1.688 0.094 2.194 0.094 6.464 0 4.269-0.019 4.768-0.094 6.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.059 7.782c-4.539 0.002-8.218 3.682-8.219 8.221v0c0.091 4.471 3.737 8.060 8.221 8.060s8.13-3.589 8.221-8.052l0-0.009c-0.001-4.54-3.681-8.22-8.221-8.221h-0zM16.059 21.334c-2.945-0-5.332-2.388-5.332-5.333s2.388-5.333 5.333-5.333c0 0 0.001 0 0.001 0h-0c2.946 0 5.334 2.388 5.334 5.334s-2.388 5.334-5.334 5.334v0zM26.525 7.458c0 1.060-0.86 1.92-1.92 1.92s-1.92-0.86-1.92-1.92v0c0-1.060 0.86-1.92 1.92-1.92s1.92 0.86 1.92 1.92v0z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.76 1.787l-0.612 0.613 13.598 13.6-13.6 13.6 0.628 0.626 0.626 0.628 13.6-13.6 13.6 13.6 0.626-0.628 0.628-0.626-13.6-13.6 13.6-13.6-0.628-0.626-0.626-0.628-13.6 13.6-6.788-6.788c-2.249-2.258-4.469-4.469-6.698-6.671l-0.116-0.114c-0.014 0-0.302 0.276-0.638 0.613z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "cart",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.26 25.686 c -0.707 -0.946 -1.789 -1.488 -2.97 -1.488 H 74.974 H 30.6 l -0.686 -2.642 c -0.595 -2.291 -2.664 -3.892 -5.031 -3.892 h -7.565 c -0.552 0 -1 0.448 -1 1 c 0 0.552 0.448 1 1 1 h 7.565 c 1.457 0 2.729 0.984 3.096 2.394 l 9.095 35.022 c 0.114 0.441 0.512 0.749 0.968 0.749 h 42.52 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 38.814 l -1.857 -7.149 h 43.176 c 2.284 0 4.332 -1.53 4.979 -3.72 l 4.732 -16.006 C 90.18 27.823 89.966 26.631 89.26 25.686 z M 87.927 28.388 l -4.732 16.006 c -0.398 1.347 -1.657 2.287 -3.061 2.287 H 36.438 l -5.319 -20.483 h 43.855 H 86.29 c 0.544 0 1.042 0.25 1.367 0.685 C 87.983 27.318 88.081 27.867 87.927 28.388 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.396 72.335 c -3.167 0 -5.743 -2.576 -5.743 -5.743 c 0 -3.166 2.576 -5.742 5.743 -5.742 c 3.166 0 5.743 2.576 5.743 5.742 C 51.139 69.759 48.563 72.335 45.396 72.335 z M 45.396 62.85 c -2.064 0 -3.743 1.679 -3.743 3.742 c 0 2.064 1.679 3.743 3.743 3.743 s 3.743 -1.679 3.743 -3.743 C 49.139 64.529 47.46 62.85 45.396 62.85 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.113 72.335 c -3.166 0 -5.742 -2.576 -5.742 -5.743 c 0 -3.166 2.576 -5.742 5.742 -5.742 c 3.167 0 5.743 2.576 5.743 5.742 C 77.856 69.759 75.28 72.335 72.113 72.335 z M 72.113 62.85 c -2.063 0 -3.742 1.679 -3.742 3.742 c 0 2.064 1.679 3.743 3.742 3.743 c 2.064 0 3.743 -1.679 3.743 -3.743 C 75.856 64.529 74.177 62.85 72.113 62.85 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.936 32.205 H 1 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 19.936 c 0.552 0 1 0.448 1 1 S 21.488 32.205 20.936 32.205 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.972 40.443 H 2.037 c -0.552 0 -1 -0.448 -1 -1 c 0 -0.552 0.448 -1 1 -1 h 19.936 c 0.552 0 1 0.448 1 1 C 22.972 39.995 22.524 40.443 21.972 40.443 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.228 48.681 H 3.292 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 19.936 c 0.552 0 1 0.447 1 1 S 23.78 48.681 23.228 48.681 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.ceedce627e8532e1fde42d6aff54a4e5.svg";
export { ForwardRef as ReactComponent };